<template>
  <div class="ticket">
    <BannerSearch> </BannerSearch>
    <div class="innerbox">

      <div class="sign-container" ref="myElement" v-if="sucess">
        <div class="sucess-ing">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="70px" height="70px">
            <path fill-rule="evenodd" fill="rgb(119, 198, 75)"
              d="M34.984,69.71 C16.173,69.71 0.924,53.821 0.924,35.10 C0.924,16.194 16.173,0.949 34.984,0.949 C53.794,0.949 69.43,16.194 69.43,35.10 C69.43,53.821 53.794,69.71 34.984,69.71 ZM34.976,10.629 C21.519,10.629 10.608,21.535 10.608,34.999 C10.608,48.454 21.519,59.369 34.976,59.369 C48.435,59.369 59.345,48.454 59.345,34.999 C59.345,21.535 48.435,10.629 34.976,10.629 ZM34.871,46.798 C34.796,46.885 34.738,46.980 34.655,47.63 C33.934,47.784 33.44,48.232 32.113,48.410 C30.551,48.731 28.864,48.290 27.652,47.78 C27.504,46.930 27.388,46.762 27.262,46.600 L19.734,39.72 C17.820,37.158 17.820,34.55 19.734,32.141 C21.648,30.227 24.751,30.227 26.665,32.141 L31.158,36.634 L42.866,24.926 C44.782,23.10 47.888,23.10 49.804,24.926 C51.720,26.842 51.720,29.949 49.804,31.865 L34.871,46.798 Z" />
          </svg>
        </div>
        <div class="sign-title">
          {{ this.$i18n.locale == "zh" ? "发送成功!" : "REQUEST RECEIVED!" }}
        </div>
        <div class="sign-text" v-if="this.$i18n.locale == 'zh'">
          工单发送成功，我们将尽快处理！<br />
          工单编号为：{{ ticketId }}
        </div>
        <div class="sign-text" v-if="this.$i18n.locale == 'en'">
          The work order has been sent successfully,<br />
          we will deal with it as soon as possible!<br />Ticket ID:{{ ticketId }}
        </div>
        <div class="submit-box">
          <a @click="backHome()" class="sub">
            <div>{{ this.$i18n.locale == "zh" ? "工单详情" : "TICKET DETAIL" }}</div>
          </a>
        </div>
        <!-- <div class="bottom-timer">
          还有 <a class="greener" href="">{{ time - 1 }}</a> 秒后跳转
        </div> -->
      </div>
      <div class="sign-container" v-else-if="warn == 1">
        <div class="sucess-ing">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="69px" height="69px">
            <path fill-rule="evenodd" fill="rgb(255, 138, 52)"
              d="M34.499,68.166 C15.645,68.166 0.499,53.21 0.499,34.166 C0.499,15.311 15.645,0.166 34.499,0.166 C53.354,0.166 68.499,15.311 68.499,34.166 C68.499,53.21 53.354,68.166 34.499,68.166 ZM34.499,9.130 C20.590,9.130 9.463,20.257 9.463,34.166 C9.463,48.75 20.590,59.202 34.499,59.202 C48.408,59.202 59.536,48.75 59.536,34.166 C59.536,20.257 48.408,9.130 34.499,9.130 ZM38.471,34.429 C38.500,36.8 38.465,37.471 37.870,38.435 C37.8,39.832 34.999,40.455 33.350,40.164 C31.463,39.830 29.975,38.362 29.975,36.549 C29.975,35.81 29.959,34.545 30.50,33.630 C30.332,30.793 32.449,30.190 34.565,29.321 C35.945,28.755 38.721,27.785 37.570,25.14 C36.955,23.533 33.748,23.15 31.438,24.229 C29.60,25.480 26.654,26.134 25.250,25.114 C24.476,24.552 23.836,23.556 23.848,22.210 C23.889,17.567 31.595,16.912 32.963,16.801 C35.433,16.601 41.992,16.696 44.898,20.240 C45.871,21.427 46.602,22.839 46.551,25.482 C46.440,31.175 42.458,32.929 38.471,34.429 ZM33.564,42.558 C40.503,42.20 41.396,50.415 35.917,51.956 C31.330,53.247 27.728,49.432 29.457,45.313 C30.222,43.490 31.607,42.707 33.564,42.558 Z" />
          </svg>
        </div>
        <div class="sign-title" style="font-size: 32px;line-height: 1.2;margin: 10px 0 ">
          {{ alert == '' ? this.$i18n.locale == "zh" ? "绑定客服编号" : "REGISTER YOUR CUSTOMER SERVICE ID" : '' }}
        </div>
        <div class="sign-text" v-if="this.$i18n.locale == 'zh'">
          {{ alert == '' ? '是否将填写的客服编号与该登录账号绑定？' : alert }}
        </div>
        <div class="sign-text" v-if="this.$i18n.locale == 'en'">
          {{ alert == '' ? 'Do you want to register this Customer Service ID to the current login account?' : alert }}
        </div>
        <div class="submit-box" v-if="alert == ''">
          <a @click="noBind()" class="sub close">
            <div>{{ this.$i18n.locale == "zh" ? "取消" : "CANCEL" }}</div>
          </a>
          <a @click="bindId()" class="sub">
            <div>{{ this.$i18n.locale == "zh" ? "绑定" : "REGISTER" }}</div>
          </a>

        </div>
        <!-- <div class="bottom-timer">
          还有 <a class="greener" href="">{{ time - 1 }}</a> 秒后跳转
        </div> -->
      </div>
      <div class="sign-container" v-else-if="warn == 2">
        <div class="sucess-ing">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="70px" height="70px">
            <path fill-rule="evenodd" fill="rgb(119, 198, 75)"
              d="M34.984,69.71 C16.173,69.71 0.924,53.821 0.924,35.10 C0.924,16.194 16.173,0.949 34.984,0.949 C53.794,0.949 69.43,16.194 69.43,35.10 C69.43,53.821 53.794,69.71 34.984,69.71 ZM34.976,10.629 C21.519,10.629 10.608,21.535 10.608,34.999 C10.608,48.454 21.519,59.369 34.976,59.369 C48.435,59.369 59.345,48.454 59.345,34.999 C59.345,21.535 48.435,10.629 34.976,10.629 ZM34.871,46.798 C34.796,46.885 34.738,46.980 34.655,47.63 C33.934,47.784 33.44,48.232 32.113,48.410 C30.551,48.731 28.864,48.290 27.652,47.78 C27.504,46.930 27.388,46.762 27.262,46.600 L19.734,39.72 C17.820,37.158 17.820,34.55 19.734,32.141 C21.648,30.227 24.751,30.227 26.665,32.141 L31.158,36.634 L42.866,24.926 C44.782,23.10 47.888,23.10 49.804,24.926 C51.720,26.842 51.720,29.949 49.804,31.865 L34.871,46.798 Z" />
          </svg>
        </div>

        <div class="sign-title" style="font-size: 32px;line-height: 1.2;margin-top: 10px;">
          {{ this.$i18n.locale == "en" ? "REGISTRATION SUCCESSFUL" : "绑定成功" }}
        </div>
        <!-- <div class="sign-text" v-if="this.$i18n.locale == 'en'">
          {{ alert == '' ? '将客服编号与你的登录账号绑定，可以让我们更快的帮你解决问题，是否绑定？' : alert }}
        </div> -->

        <div class="bottom-timer">
          {{ this.$i18n.locale == "en" ? "Your Customer Service ID has been successfully registered. Redirecting in" :
            "已成功绑定客服编号倒计时" }} <a class="greener" href="">{{ time }}</a> {{ this.$i18n.locale == "en" ? " seconds... " : " 秒"
  }}
        </div>
      </div>
      <div class="sign-container" v-else-if="warn == 3">
        <div class="sucess-ing">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="70px" height="70px">
            <path fill-rule="evenodd" fill="rgb(119, 198, 75)"
              d="M34.984,69.71 C16.173,69.71 0.924,53.821 0.924,35.10 C0.924,16.194 16.173,0.949 34.984,0.949 C53.794,0.949 69.43,16.194 69.43,35.10 C69.43,53.821 53.794,69.71 34.984,69.71 ZM34.976,10.629 C21.519,10.629 10.608,21.535 10.608,34.999 C10.608,48.454 21.519,59.369 34.976,59.369 C48.435,59.369 59.345,48.454 59.345,34.999 C59.345,21.535 48.435,10.629 34.976,10.629 ZM34.871,46.798 C34.796,46.885 34.738,46.980 34.655,47.63 C33.934,47.784 33.44,48.232 32.113,48.410 C30.551,48.731 28.864,48.290 27.652,47.78 C27.504,46.930 27.388,46.762 27.262,46.600 L19.734,39.72 C17.820,37.158 17.820,34.55 19.734,32.141 C21.648,30.227 24.751,30.227 26.665,32.141 L31.158,36.634 L42.866,24.926 C44.782,23.10 47.888,23.10 49.804,24.926 C51.720,26.842 51.720,29.949 49.804,31.865 L34.871,46.798 Z" />
          </svg>
        </div>

        <div class="sign-text" v-if="this.$i18n.locale == 'zh'">
          {{ alert }}
        </div>
        <div class="submit-box">
          <a @click="warn = false" class="sub">
            <div>{{ '返回' }}</div>
          </a>
        </div>
      </div>
      <div class="msg-box" id="msg-box" v-else>
        <img class="nemo" src="../assets/images/submit_animal.png" alt="">
        <div class="title">{{ $t("m.ticket.title") }}</div>
        <div v-if="this.$store.state.ticketFields != '' && posting == false">

          <div v-for="(field, index) in this.$store.state.ticketFields" :key="index">
            <!-- {{ field }} -->
            <div class="label" v-if="field.config.hidden != true">
              {{ field.config.field_name == 'TextField_1369' ? $t('m.ticket.custid') : field.value.field_label }}
              <span class="field-after" v-if="field.config.required != true">{{ $t("m.ticket.attachafter") }}</span>
              <div class="found" @click="openFound()" v-if="field.config.field_name == 'TextField_1369'"> <svg
                  xmlns="http://www.w3.org/2000/svg" class="found-svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="19px" height="19px">
                  <path class="found-path" fill-rule="evenodd" fill="rgb(137, 137, 137)"
                    d="M9.749,18.658 C4.620,18.658 0.499,14.538 0.499,9.408 C0.499,4.279 4.620,0.158 9.749,0.158 C14.879,0.158 18.999,4.279 18.999,9.408 C18.999,14.538 14.879,18.658 9.749,18.658 ZM9.749,2.597 C5.965,2.597 2.938,5.624 2.938,9.408 C2.938,13.193 5.965,16.220 9.749,16.220 C13.534,16.220 16.561,13.193 16.561,9.408 C16.561,5.624 13.534,2.597 9.749,2.597 ZM10.830,9.480 C10.838,9.909 10.828,10.308 10.666,10.570 C10.432,10.950 9.885,11.119 9.437,11.40 C8.923,10.950 8.518,10.550 8.518,10.57 C8.518,9.657 8.514,9.512 8.539,9.263 C8.616,8.491 9.192,8.327 9.767,8.90 C10.143,7.936 10.898,7.672 10.585,6.919 C10.417,6.516 9.545,6.375 8.917,6.705 C8.270,7.45 7.615,7.223 7.233,6.946 C7.22,6.793 6.848,6.522 6.852,6.156 C6.863,4.893 8.959,4.714 9.331,4.684 C10.3,4.630 11.788,4.656 12.578,5.620 C12.843,5.943 13.42,6.327 13.28,7.46 C12.998,8.595 11.915,9.72 10.830,9.480 ZM9.495,11.692 C11.383,11.545 11.626,13.829 10.135,14.249 C8.887,14.600 7.907,13.562 8.378,12.441 C8.586,11.945 8.963,11.732 9.495,11.692 Z" />
                </svg></div>
              <!--  -->
              <transition name="fade">
                <div class="found-page" ref="found" v-if="field.config.field_name == 'TextField_1369' && isFound">
                  <svg data-v-61dd7a3d="" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="29px" height="29px" class="svg-close" style="opacity: 1;">
                    <path data-v-61dd7a3d="" fill-rule="evenodd" fill="rgb(95, 95, 95)"
                      d="M28.071,4.817 L18.276,14.612 L27.893,24.228 C28.674,25.009 28.674,26.275 27.893,27.056 L27.268,27.682 C26.487,28.463 25.220,28.463 24.439,27.682 L14.823,18.065 L4.998,27.890 C4.217,28.671 2.951,28.671 2.170,27.890 L1.545,27.265 C0.764,26.484 0.764,25.217 1.545,24.436 L11.369,14.612 L1.366,4.609 C0.585,3.828 0.585,2.561 1.366,1.780 L1.992,1.155 C2.773,0.374 4.039,0.374 4.820,1.155 L14.823,11.158 L24.618,1.364 C25.399,0.582 26.665,0.582 27.446,1.364 L28.071,1.989 C28.852,2.770 28.852,4.036 28.071,4.817 Z">
                    </path>
                  </svg>
                  <div class="img-box" v-if="$i18n.locale == 'zh'">
                    <img class="id-step-bg" src="../assets/images/id_step_bg@2x.png" alt="" srcset="">
                    <div class="step">
                      <div class="txt">1. 在游戏内点击“游戏设置”</div><img src="../assets/images/id_step_01@2x.png" alt="">
                    </div>
                    <div class="step two">
                      <div class="txt">2. 在“通用”选项卡内拉到页面底部<br class="br" />找到“我的客服编号”，点击查看
                      </div><img src="../assets/images/id_step_02@2x.png" alt="">
                    </div>
                    <div class="step">
                      <div class="txt">3. 点击“显示”图标<br class="br" />显示你的客服编号，点击编号复制
                      </div><img src="../assets/images/id_step_03@2x.png" alt="">
                    </div>
                  </div>
                  <div class="img-box en" v-else>
                    <img class="id-step-bg" src="../assets/images/id_step_bg@2x.png" alt="" srcset="">
                    <div class="step">
                      <div class="txt">1. Click "Settings" within the game</div><img
                        src="../assets/images/id_step_01_en@2x.png" alt="">
                    </div>
                    <div class="step two">
                      <div class="txt">2. Scroll to the bottom of the "General" tab<br class="br" />find "My Customer
                        Service ID", and click "Inspect"
                      </div><img src="../assets/images/id_step_02_en@2x.png" alt="">
                    </div>
                    <div class="step">
                      <div class="txt">3. Click the View icon to reveal your Customer Service ID or click the ID itself to
                        conveniently copy it
                      </div><img src="../assets/images/id_step_03_en@2x.png" alt="">
                    </div>
                  </div>
                </div>
              </transition>
              <div v-if="field.value.content_type == 'chained_droplist' || field.value.content_type == 'radio'"
                class="check-list">

                <MyCascader ref="select" :options="field.value.select_options" :placeholders="field.field_detail"
                  :placeholder="parseStringToListItems(field.field_detail)[0].content"
                  @change="handleCascaderChange($event, field.config.field_name)" />
              </div>
              <div v-else-if="field.value.content_type == 'area_text' || field.value.content_type == 'rich_text'">
                <div class="input-box">

                  <textarea @change="input(field.config.field_name)" rows="4" v-model="ticket[field.config.field_name]"
                    :placeholder="field.field_detail" @dragleave="handleDragLeave" @dragover="handleDragOver"
                    @drop="handleDrop"> </textarea>
                </div>
                <p class="alert-text"
                  v-if="field.config.required == true && ticketAlert.indexOf(field.config.field_name) != -1">
                  <svg data-v-700d1935="" version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 22 22" xml:space="preserve"
                    style="width:14px;fill-rule: evenodd; clip-rule: evenodd; fill: rgb(244, 109, 91);">
                    <g data-v-700d1935="">
                      <path data-v-700d1935="" d="M11,0C4.9,0,0,4.9,0,11s4.9,11,11,11s11-4.9,11-11S17.1,0,11,0z M11,19.1c-4.5,0-8.1-3.6-8.1-8.1
		S6.5,2.9,11,2.9s8.1,3.6,8.1,8.1S15.5,19.1,11,19.1z" class="st0"></path>
                      <path data-v-700d1935=""
                        d="M11,12.3c0.9,0,1.6-0.7,1.6-1.6V6.1c0-0.9-0.7-1.6-1.6-1.6S9.4,5.2,9.4,6.1v4.6C9.4,11.6,10.1,12.3,11,12.3z"
                        class="st0"></path>
                      <circle data-v-700d1935="" cx="11" cy="15.2" r="1.9" class="st0"></circle>
                    </g>
                  </svg>{{ $t("m.ticket.alert1") }}
                </p>
                <p class="alert-text" v-if="custCheck != '' && field.config.field_name == 'TextField_1369'">
                  <svg data-v-700d1935="" version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 22 22" xml:space="preserve"
                    style="width:14px;fill-rule: evenodd; clip-rule: evenodd; fill: rgb(244, 109, 91);">
                    <g data-v-700d1935="">
                      <path data-v-700d1935="" d="M11,0C4.9,0,0,4.9,0,11s4.9,11,11,11s11-4.9,11-11S17.1,0,11,0z M11,19.1c-4.5,0-8.1-3.6-8.1-8.1
		S6.5,2.9,11,2.9s8.1,3.6,8.1,8.1S15.5,19.1,11,19.1z" class="st0"></path>
                      <path data-v-700d1935=""
                        d="M11,12.3c0.9,0,1.6-0.7,1.6-1.6V6.1c0-0.9-0.7-1.6-1.6-1.6S9.4,5.2,9.4,6.1v4.6C9.4,11.6,10.1,12.3,11,12.3z"
                        class="st0"></path>
                      <circle data-v-700d1935="" cx="11" cy="15.2" r="1.9" class="st0"></circle>
                    </g>
                  </svg>{{ custCheck }}
                </p>
                <div class="label attach">
                  <span>{{ $t("m.ticket.attach") }}</span>
                  <span class="attach-after">{{ $t("m.ticket.attachafter") }}</span>
                  <div :class="{ 'drag-over': isDragOver }" class="input-box attach" @click="choiceFile()"
                    @dragleave="handleDragLeave" @dragover="handleDragOver" @drop="handleDrop">
                    <input style="display:none" type="file" id="file" ref="file" name="myfile"
                      @change="attachment($event)"
                      accept=".jpg,.jpeg,.png,.gif,.mpg,.mpeg,.xls,.xlsx,.ppt,.pptx,.doc,.docx,.pdf,.word,.txt,.mp3,.mp4,.avi,.amr,.wav,.m4a,.mov,.eml,.csv,.rar,.zip,.gz" />
                    <span class="drop win"><svg xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" width="26px" height="22px">
                        <path fill-rule="evenodd" stroke="rgb(1, 1, 1)" stroke-width="0px" stroke-linecap="butt"
                          stroke-linejoin="miter" opacity="0.4" fill="rgb(56, 59, 66)"
                          d="M25.314,16.920 L24.621,20.725 C24.464,21.360 23.769,21.880 23.076,21.880 L12.999,21.880 L2.924,21.880 C2.231,21.880 1.535,21.360 1.378,20.725 L0.684,16.920 C0.527,16.285 0.829,15.522 1.212,14.987 L5.110,10.361 L5.112,10.361 L5.187,10.310 C5.189,10.310 5.190,10.308 5.190,10.308 C5.334,10.220 5.505,10.170 5.685,10.170 L6.870,10.170 C7.052,10.170 7.217,10.246 7.332,10.369 L7.373,10.416 L7.709,10.844 L7.730,10.867 C7.775,10.922 7.803,10.995 7.803,11.071 C7.803,11.243 7.666,11.385 7.493,11.390 L7.472,11.390 L6.762,11.390 L6.762,11.391 C6.554,11.391 6.368,11.491 6.252,11.646 C6.251,11.646 6.250,11.647 6.250,11.647 C6.236,11.667 6.222,11.689 6.210,11.710 C6.208,11.712 6.208,11.712 6.208,11.714 C5.638,12.576 3.994,14.873 3.931,14.987 C3.853,15.126 3.774,15.339 3.803,15.454 C3.846,15.618 3.996,15.692 4.164,15.704 C4.171,15.706 4.178,15.706 4.185,15.706 C4.193,15.706 4.200,15.706 4.208,15.704 L7.130,15.704 L7.327,15.704 C7.873,15.741 8.337,16.083 8.546,16.560 L8.610,16.734 L9.070,18.450 C9.072,18.455 9.074,18.461 9.076,18.467 C9.211,18.823 9.549,19.079 9.949,19.087 C9.957,19.089 9.965,19.089 9.974,19.089 C9.982,19.089 9.990,19.089 9.998,19.087 L12.999,19.087 L16.000,19.087 C16.009,19.089 16.017,19.089 16.026,19.089 C16.034,19.089 16.042,19.089 16.050,19.087 C16.449,19.079 16.788,18.823 16.923,18.467 C16.925,18.461 16.927,18.455 16.929,18.450 L17.389,16.734 L17.453,16.560 C17.663,16.083 18.127,15.741 18.671,15.704 L18.868,15.704 L21.791,15.704 C21.799,15.706 21.805,15.706 21.813,15.706 C21.821,15.706 21.828,15.706 21.836,15.704 C22.004,15.692 22.154,15.618 22.197,15.454 C22.226,15.339 22.147,15.126 22.069,14.987 C22.005,14.871 20.312,12.502 19.765,11.673 C19.650,11.503 19.456,11.391 19.235,11.391 L19.235,11.390 L18.527,11.390 L18.505,11.390 C18.334,11.385 18.197,11.243 18.197,11.071 C18.197,10.995 18.223,10.922 18.269,10.867 L18.290,10.844 L18.626,10.416 L18.666,10.369 C18.782,10.246 18.947,10.170 19.130,10.170 L20.314,10.170 C20.495,10.170 20.665,10.220 20.809,10.308 C20.810,10.308 20.811,10.310 20.811,10.310 L20.888,10.361 L20.889,10.361 L24.786,14.987 C25.170,15.522 25.472,16.285 25.314,16.920 ZM18.414,8.322 L18.414,8.324 L16.499,8.324 L16.392,8.324 C15.933,8.350 15.562,8.705 15.512,9.159 L15.512,9.372 L15.512,13.917 L15.512,14.171 C15.450,14.631 15.056,14.987 14.580,14.987 L11.425,14.987 C10.941,14.987 10.543,14.621 10.490,14.150 L10.490,13.939 L10.490,9.282 C10.490,9.276 10.490,9.270 10.490,9.265 C10.490,9.259 10.490,9.253 10.490,9.249 C10.482,8.754 10.093,8.351 9.604,8.324 L9.496,8.324 L7.586,8.324 L7.586,8.322 C7.240,8.322 6.959,8.041 6.959,7.695 C6.959,7.568 6.997,7.448 7.062,7.351 L7.147,7.247 L12.275,1.022 C12.447,0.813 12.708,0.680 13.001,0.680 C13.293,0.680 13.554,0.813 13.727,1.022 L18.860,7.253 L18.931,7.339 C19.000,7.440 19.041,7.564 19.041,7.695 C19.041,8.041 18.760,8.322 18.414,8.322 Z" />
                      </svg>
                      {{ $t('m.ticketdetail.drop') }} <a style="color:#ffc000">{{ $t('m.ticketdetail.dropa')
                      }}</a>
                    </span>
                    <span class="drop moblie"><svg xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" width="26px" height="22px">
                        <path fill-rule="evenodd" stroke="rgb(1, 1, 1)" stroke-width="0px" stroke-linecap="butt"
                          stroke-linejoin="miter" opacity="0.4" fill="rgb(56, 59, 66)"
                          d="M25.314,16.920 L24.621,20.725 C24.464,21.360 23.769,21.880 23.076,21.880 L12.999,21.880 L2.924,21.880 C2.231,21.880 1.535,21.360 1.378,20.725 L0.684,16.920 C0.527,16.285 0.829,15.522 1.212,14.987 L5.110,10.361 L5.112,10.361 L5.187,10.310 C5.189,10.310 5.190,10.308 5.190,10.308 C5.334,10.220 5.505,10.170 5.685,10.170 L6.870,10.170 C7.052,10.170 7.217,10.246 7.332,10.369 L7.373,10.416 L7.709,10.844 L7.730,10.867 C7.775,10.922 7.803,10.995 7.803,11.071 C7.803,11.243 7.666,11.385 7.493,11.390 L7.472,11.390 L6.762,11.390 L6.762,11.391 C6.554,11.391 6.368,11.491 6.252,11.646 C6.251,11.646 6.250,11.647 6.250,11.647 C6.236,11.667 6.222,11.689 6.210,11.710 C6.208,11.712 6.208,11.712 6.208,11.714 C5.638,12.576 3.994,14.873 3.931,14.987 C3.853,15.126 3.774,15.339 3.803,15.454 C3.846,15.618 3.996,15.692 4.164,15.704 C4.171,15.706 4.178,15.706 4.185,15.706 C4.193,15.706 4.200,15.706 4.208,15.704 L7.130,15.704 L7.327,15.704 C7.873,15.741 8.337,16.083 8.546,16.560 L8.610,16.734 L9.070,18.450 C9.072,18.455 9.074,18.461 9.076,18.467 C9.211,18.823 9.549,19.079 9.949,19.087 C9.957,19.089 9.965,19.089 9.974,19.089 C9.982,19.089 9.990,19.089 9.998,19.087 L12.999,19.087 L16.000,19.087 C16.009,19.089 16.017,19.089 16.026,19.089 C16.034,19.089 16.042,19.089 16.050,19.087 C16.449,19.079 16.788,18.823 16.923,18.467 C16.925,18.461 16.927,18.455 16.929,18.450 L17.389,16.734 L17.453,16.560 C17.663,16.083 18.127,15.741 18.671,15.704 L18.868,15.704 L21.791,15.704 C21.799,15.706 21.805,15.706 21.813,15.706 C21.821,15.706 21.828,15.706 21.836,15.704 C22.004,15.692 22.154,15.618 22.197,15.454 C22.226,15.339 22.147,15.126 22.069,14.987 C22.005,14.871 20.312,12.502 19.765,11.673 C19.650,11.503 19.456,11.391 19.235,11.391 L19.235,11.390 L18.527,11.390 L18.505,11.390 C18.334,11.385 18.197,11.243 18.197,11.071 C18.197,10.995 18.223,10.922 18.269,10.867 L18.290,10.844 L18.626,10.416 L18.666,10.369 C18.782,10.246 18.947,10.170 19.130,10.170 L20.314,10.170 C20.495,10.170 20.665,10.220 20.809,10.308 C20.810,10.308 20.811,10.310 20.811,10.310 L20.888,10.361 L20.889,10.361 L24.786,14.987 C25.170,15.522 25.472,16.285 25.314,16.920 ZM18.414,8.322 L18.414,8.324 L16.499,8.324 L16.392,8.324 C15.933,8.350 15.562,8.705 15.512,9.159 L15.512,9.372 L15.512,13.917 L15.512,14.171 C15.450,14.631 15.056,14.987 14.580,14.987 L11.425,14.987 C10.941,14.987 10.543,14.621 10.490,14.150 L10.490,13.939 L10.490,9.282 C10.490,9.276 10.490,9.270 10.490,9.265 C10.490,9.259 10.490,9.253 10.490,9.249 C10.482,8.754 10.093,8.351 9.604,8.324 L9.496,8.324 L7.586,8.324 L7.586,8.322 C7.240,8.322 6.959,8.041 6.959,7.695 C6.959,7.568 6.997,7.448 7.062,7.351 L7.147,7.247 L12.275,1.022 C12.447,0.813 12.708,0.680 13.001,0.680 C13.293,0.680 13.554,0.813 13.727,1.022 L18.860,7.253 L18.931,7.339 C19.000,7.440 19.041,7.564 19.041,7.695 C19.041,8.041 18.760,8.322 18.414,8.322 Z" />
                      </svg>
                      {{ $t('m.ticketdetail.dropShort') }}

                    </span>
                  </div>
                  <div class="alert black " :class="{ big: $i18n.locale == 'zh' }">
                    {{ $t("m.ticket.limit") }}
                  </div>
                </div>
                <transition-group name="fade">
                  <div class="update" v-for="item, index in attachments" :key="item.name">
                    <div @click="openAtt(item.url)" class="single-line-ellipsis">
                      <svg class="link" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="20px" height="21px">
                        <path fill-rule="evenodd" stroke="rgb(137, 137, 137)" stroke-width="2px" stroke-linecap="round"
                          stroke-linejoin="miter" fill="none"
                          d="M9.645,7.988 C9.056,8.608 5.398,12.385 4.772,13.044 C4.319,13.520 4.348,14.359 4.796,14.830 C5.244,15.301 6.034,15.325 6.487,14.849 C6.864,14.452 14.363,6.557 14.245,6.682 C15.142,5.737 15.091,4.078 14.195,3.136 C13.300,2.194 11.712,2.126 10.815,3.071 C9.572,4.379 4.246,9.987 3.077,11.217 C1.890,12.467 1.645,15.156 3.070,16.655 C4.495,18.155 6.808,18.152 8.236,16.649 C9.665,15.145 16.099,8.446 16.099,8.446 " />
                      </svg>
                      {{ item.name }}
                    </div>

                    <svg class="close" v-if="!item.url" xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink" style="display:block;margin:0 -5px 0 0;" width="22px"
                      height="22px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                      <circle cx="50" cy="50" fill="none" stroke="#ffbf5a" stroke-width="14" r="27"
                        stroke-dasharray="127.23450247038662 44.411500823462205">
                        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite"
                          dur="1.7543859649122806s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                      </circle>
                    </svg>
                    <svg class="close" v-else xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink" width="12px" height="12px"
                      @click="closeAttachment(index)">
                      <path fill-rule="evenodd" stroke="rgb(137, 137, 137)" stroke-width="2px" stroke-linecap="round"
                        stroke-linejoin="miter" fill="none" d="M9.000,2.000 L2.000,8.999 " />
                      <path fill-rule="evenodd" stroke="rgb(137, 137, 137)" stroke-width="2px" stroke-linecap="round"
                        stroke-linejoin="miter" fill="none" d="M2.000,2.000 L9.000,8.999 " />
                    </svg>
                  </div>

                </transition-group>

              </div>
              <div v-else-if="field.config.field_name == 'TextField_1369'">

                <div class="input-box" :style="getCookie('cust_id_game') != '' ? {} : {}">
                  <input @change="input(field.config.field_name)" v-model="ticket.TextField_1369"
                    :disabled="getCookie('cust_id_game') != ''" :placeholder="$t('m.ticket.custplace')" />
                </div>

              </div>
              <div v-else>
                <div class="input-box">
                  <input @change="input(field.config.field_name)" v-model="ticket[field.config.field_name]"
                    :placeholder="field.field_detail" />
                </div>

              </div>
            </div>

            <!-- <div class="detail-text" v-if="field.field_detail">
              {{ field.field_detail }}
            </div> -->
            <p class="alert-text"
              v-if="field.config.required == true && ticketAlert.indexOf(field.config.field_name) != -1 && field.value.content_type != 'area_text'">
              <svg data-v-700d1935="" version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 22 22" xml:space="preserve"
                style="width:14px;fill-rule: evenodd; clip-rule: evenodd; fill: rgb(244, 109, 91);">
                <g data-v-700d1935="">
                  <path data-v-700d1935="" d="M11,0C4.9,0,0,4.9,0,11s4.9,11,11,11s11-4.9,11-11S17.1,0,11,0z M11,19.1c-4.5,0-8.1-3.6-8.1-8.1
		S6.5,2.9,11,2.9s8.1,3.6,8.1,8.1S15.5,19.1,11,19.1z" class="st0"></path>
                  <path data-v-700d1935=""
                    d="M11,12.3c0.9,0,1.6-0.7,1.6-1.6V6.1c0-0.9-0.7-1.6-1.6-1.6S9.4,5.2,9.4,6.1v4.6C9.4,11.6,10.1,12.3,11,12.3z"
                    class="st0"></path>
                  <circle data-v-700d1935="" cx="11" cy="15.2" r="1.9" class="st0"></circle>
                </g>
              </svg>{{ $t("m.ticket.alert1") }}
            </p>
            <p class="alert-text" v-if="custCheck != '' && field.config.field_name == 'TextField_1369'">
              <svg data-v-700d1935="" version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 22 22" xml:space="preserve"
                style="width:14px;fill-rule: evenodd; clip-rule: evenodd; fill: rgb(244, 109, 91);">
                <g data-v-700d1935="">
                  <path data-v-700d1935="" d="M11,0C4.9,0,0,4.9,0,11s4.9,11,11,11s11-4.9,11-11S17.1,0,11,0z M11,19.1c-4.5,0-8.1-3.6-8.1-8.1
		S6.5,2.9,11,2.9s8.1,3.6,8.1,8.1S15.5,19.1,11,19.1z" class="st0"></path>
                  <path data-v-700d1935=""
                    d="M11,12.3c0.9,0,1.6-0.7,1.6-1.6V6.1c0-0.9-0.7-1.6-1.6-1.6S9.4,5.2,9.4,6.1v4.6C9.4,11.6,10.1,12.3,11,12.3z"
                    class="st0"></path>
                  <circle data-v-700d1935="" cx="11" cy="15.2" r="1.9" class="st0"></circle>
                </g>
              </svg>{{ custCheck }}
            </p>
          </div>

          <div class="label" v-if="$store.state.captcha.url != ''">
            {{ $t("m.ticket.cap") }}
            <div class="cap-box" style="display:flex;align-items: flex-start;">
              <div class="input-box" style="width:75%">
                <input v-model="capInput" :placeholder="$t('m.ticket.codeplace')" />
              </div>
              <img style="height:48px" :src="$store.state.captcha.url" alt="" @click="getCaptcha()">
            </div>
            <p class="alert-text" v-if="captchaAlert"><svg data-v-700d1935="" version="1.1" id="图层_1"
                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 22 22" xml:space="preserve"
                style="width:14px;fill-rule: evenodd; clip-rule: evenodd; fill: rgb(244, 109, 91);">
                <g data-v-700d1935="">
                  <path data-v-700d1935="" d="M11,0C4.9,0,0,4.9,0,11s4.9,11,11,11s11-4.9,11-11S17.1,0,11,0z M11,19.1c-4.5,0-8.1-3.6-8.1-8.1
		S6.5,2.9,11,2.9s8.1,3.6,8.1,8.1S15.5,19.1,11,19.1z" class="st0"></path>
                  <path data-v-700d1935=""
                    d="M11,12.3c0.9,0,1.6-0.7,1.6-1.6V6.1c0-0.9-0.7-1.6-1.6-1.6S9.4,5.2,9.4,6.1v4.6C9.4,11.6,10.1,12.3,11,12.3z"
                    class="st0"></path>
                  <circle data-v-700d1935="" cx="11" cy="15.2" r="1.9" class="st0"></circle>
                </g>
              </svg>{{ captchaAlert }}</p>
          </div>

          <div class="sub-btn">
            <a @click="submit()" v-if="canSubmit && capAccept" id="btn">{{ $t('m.ticketdetail.sub') }}</a>
            <a v-else id="btn">{{ $t('m.ticketdetail.sub') }}</a>
          </div>

        </div>
        <Loading v-else :bgColor="''"></Loading>
        <img class="post" src="../assets/images/submit_post.png" alt="">
      </div>
    </div>
    <AlertSideBar ref="AlertSideBar"></AlertSideBar>
  </div>
</template>
    
<script>
import BannerSearch from "../components/BannerSearch.vue";
import ChainedDropList from "../components/ChainedDropList.vue";
import Btn from "../components/Btn.vue";
import AlertSideBar from "../components/AlertSideBar.vue";
import MyCascader from "../components/MyCascader.vue";

import Loading from "../components/Loading.vue";
export default {
  components: { BannerSearch, ChainedDropList, Btn, AlertSideBar, MyCascader, Loading },
  // inject: ['loading', 'stopLoading'],
  data() {
    return {
      check: false,
      li: ["Any", "Solving", "Reply Recelved", "Solved"],
      sdk: "",
      custCheck: '',
      listRes: [],
      middle: [],
      checkboxAlert: "",
      captchaAlert: '',
      ticket: {
        'TextField_1369': this.getCookie('cust_id_game')
      },
      ticketAlert: '',
      posting: false,
      alert: '',
      attachment_ids: [],
      attachments: [],
      options: [],
      captcha: {
        key: '',
        url: '',
      },
      capInput: '',
      warn: false,
      sucess: false,
      time: 10,
      selectedValue: null,
      ticketId: '',
      pushId: "",
      isFound: false,
      isDragOver: false,
      load: false,
      canSubmit: true,
      capAccept:true
    };
  },
  beforeRouteLeave(to, from, next) {
    // 重置数据为初始值
    this.$store.commit("SaveTicket", {});
    // ... 其他需要重置的属性

    next(true);
  },

  created() {
    console.log(this.ticket);

  },
  mounted() {


    this.ticket = {}
    this.getCaptcha()
    document.addEventListener('click', event => {
      var a = document.querySelector('.found-svg')
      var b = document.querySelector('.found-path')
      var d = document.querySelector('.found')
      var c = document.querySelector('.found-page')

      if (event.target != a && event.target != b && event.target != c && event.target != d) {
        this.isFound = false
      }
    })



    this.ticket.TextField_1369 = this.getCookie('cust_id_game')
    // if (this.$store.state.ticket != {}) {
    //   this.ticket = this.$store.state.ticket
    //   let timer = setInterval(() => {
    //     if (typeof (this.$store.state.ticketFields) != "undefined") {

    //       clearInterval(timer)
    //       this.ticketDetail = this.$store.state.ticketFields
    //       console.log();

    //       
    //       this.getCaptcha()
    //     }
    //   }, 500);

    // }
  },
  watch: {
    sucess(newVal, oldVal) {
      this.scrollToElement()
    },
    warn(newVal, oldVal) {
      this.scrollToElement()
    },
    posting(newVal, oldVal) {
      this.scrollToElement()
    },
    'ticket.TextField_1369': {

      handler(val, oldVal) {
        console.log(val);

      },
      deep: true
    },
  },
  methods: {
    waitForUdeskReady(cb) {
      var u = this.$udesk

      if (u.isReady == true && this.$backend.isReady) {

        cb()
        return
      }
      function wait() {
        if (u.isReady == true && Vue.prototype.$backend.isReady) {

          cb()
        }
        else {
          setTimeout(wait, 250);
        }
      }
      wait()
    },
    handlePageClick(event) {
      // 在这里处理页面点击事件
      console.log('Page clicked!', event);
    },
    handleDragOver(event) {
      event.preventDefault(); // 阻止默认行为
      this.isDragOver = true;

    },
    handleDragLeave(event) {
      event.preventDefault(); // 阻止默认行为
      this.isDragOver = false;

    },
    handleDrop(event) {
      this.isDragOver = false;
      event.preventDefault();
      console.log(event.dataTransfer.files);
      const files = Array.from(event.dataTransfer.files);

      files.map(file => {
        console.log(file);

        this.attachments.push({
          name: file.name,
          url: '',
        })
        this.$udesk
          .sdk.request().uploadAttachment(file).then((res) => {
            console.log(res);
            this.attachment_ids.push(res.attachment_id)
            this.attachments.map(item => {
              if (item.name == file.name) {
                item.url = res.src
              }
            })
          })
      })
    },
    parseStringToListItems(inputString) {
      const regex = /(\d+\.\s+)(.*?)(?=\d+\.\s+|\n|$)/g;
      const items = inputString.match(regex);

      if (!items) return [];

      return items.map((item) => {
        const [_, index, content] = item.match(/(\d+\.\s+)(.*)/);
        return {
          index: parseInt(index, 10),
          content: content.trim(),
        };
      });
    },
    openFound() {
      console.log(this.isFound);
      this.isFound = true

    },
    scrollToElement() {

      window.scrollTo({
        top: '280',

      });
    },
    getCookie(name) {
      var strcookie = document.cookie; //获取cookie字符串
      var arrcookie = strcookie.split("; "); //分割
      //遍历匹配
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name) {
          return arr[1];
        }
      }
      return "";
    },
    handleCascaderChange(event, value) {
      console.log(event, value);

      let string = ''
      event.map(i => {
        string = string + "," + i
      })
      this.ticket[value] = string.replace(",", '')
      console.log(this.ticket[value]);
    },
    backHome() {
      this.$router.push('/tickets/my-tickets/' + this.pushId)
    },
    go() {
      let timer = setInterval(() => {
        this.time--
        if (this.time == 0) {
          clearInterval(timer)
          this.$router.push('/tickets/my-tickets')
        }
      }, 1000);
    },
    getCaptcha() {
      if (this.$store.state.ticketFields == '') {
        this.$router.push('/login')
      }
      this.$udesk.sdk.request().getCaptcha().then(res => {
        const { code = '', captcha = null } = res || {};
        console.log(res);
        if (code === 1000) {
          this.$store.commit("SaveCaptcha", captcha);
        }
      }).catch(err => {

        console.log(err);
      })
    },
    getCookieNew(name, path) {
      const cookies = document.cookie.split('; ')
      console.log(cookies);
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].split('=')
        if (cookie[0] === name && cookie[2] === path) {
          if (condition) {

          }
          return cookie[1]
        }
      }
      return null
    },
    input(value) {
      console.log(value);
    },
    select(value) {
      // this.middle[value] = this.middle[value]
      let string = ''
      console.log(this.middle);
      this.middle[value].map(i => {
        string = string + "," + i
      })

      this.ticket[value] = string.replace(",", '')
      console.log(this.ticket[value]);
    },
    checkout() {
      this.$store.state.ticketFields.map(item => {
        if (item.config.required) {
          console.log(typeof (this.ticket[item.config.field_name]) == "undefined" || this.ticket[item.config.field_name].trim() == '');
          if (typeof (this.ticket[item.config.field_name]) == "undefined" || this.ticket[item.config.field_name].trim() == '') {
            this.ticketAlert = this.ticketAlert + item.config.field_name
            console.log(this.ticketAlert);
          } else {
            console.log(this.ticketAlert);
            this.ticketAlert = this.ticketAlert.replaceAll(item.config.field_name, '')
            console.log(this.ticketAlert);
          }
        }
      })
    },
    openAtt(url) {
      window.open(url)
    },
    closeAttachment(index) {
      this.attachments.splice(index, 1)
      this.attachment_ids.splice(index, 1)
      console.log(this.attachments)
    },

    choiceFile() {
      console.log(this.$refs.file);
      this.$refs.file[0].click()
    },
    attachment(e) {
      const file = e.target.files[0];
      console.log(e.target.files[0]);

      this.attachments.push({
        name: file.name,
        url: '',
      })
      this.$udesk
        .sdk.request().uploadAttachment(file).then((res) => {
          console.log(res);
          this.attachment_ids.push(res.attachment_id)
          this.attachments.map(item => {
            if (item.name == file.name) {
              item.url = res.src
            }
          })
        })

    },
    getMsgFormSon(data) {
      if (data.subs) {
        this.listRes.push(data.title)
        console.log(this.listRes);
      }
    },
    setIframeHeight(iframe) {
      if (iframe) {
        var iframeWin = iframe.contentWindow || iframe.contentDocument.parentWindow;
        if (iframeWin.document.body) {
          iframe.height = iframeWin.document.body.scrollHeight;

        }
      }
    },


    async submit() {
      this.checkout()
      var count = true

      // if (!this.check) {
      //   this.checkboxAlert = "请阅读并确认";
      //   count = false;
      // } else {
      //   this.checkboxAlert = "";
      // }
      if (this.capInput.length != 4) {
        console.log();
        this.captchaAlert = this.$t('m.ticket.codeAlert');
        count = false;
      } else {
        this.captchaAlert = "";
      }
      this.custCheck = ''
      var isBindCustId = false
      console.log(this.ticket);
      this.canSubmit = false;
      if (this.ticket.hasOwnProperty("TextField_1369") && this.ticket.TextField_1369.trim().length != 0) {
        console.log(this.ticket.TextField_1369.trim().length);
        if (this.ticket.TextField_1369.trim().length < 7 || this.ticket.TextField_1369.trim().length > 8) {
          this.custCheck = this.$t('m.bind.alert')
          
          this.canSubmit = true;
        } else {
          this.ticket.TextField_1369 = this.ticket.TextField_1369.toUpperCase()
          console.log(document.cookie);
          try {
            await this.$axios({
              method: 'post',
              url: this.$backend.host,
              headers: {
                'x-source': 'Nemo',
                jwt: localStorage.getItem('result_code'),
                // jwt: "eyJhbGciOiJQUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbnYiOiJTdGFuZGFsb25lIiwiZXhwIjoxNjY1NDk0ODUwLCJpYXQiOjE2NjU0NjYwNTAsImlkIjoiUktHTUM3IiwiaXNzIjoiUmVjcmVhdGUiLCJqdGkiOiI3cmhsSE0xdkM1VzlicTBYS2ctNFJ3Iiwiand0VHlwZSI6Ik9mZmljaWFsU2l0ZSIsIm5iZiI6MTY2NTQ2NjA1MCwicGxhdGZvcm1fdHlwZSI6MCwic3ViIjoiSHVydEVhY2hPdGhlciJ9.mDht7GqEFDuXbL9zX1JrXcUmvy2b2bExanXA_sNngd2w9r4meeIVj49NgecF39bw4o5Q8hTva4YJLJOiirk2eI4R_HtYF77acTbYwXlGk_xb1ZzV6nGjTJ-c6IAkg0-aQi913fptAryYQKXfLy2iMJGXs4pFTgWEpSmWgCor6e6wrEAJytUCq-DBS9dWVAEhOk2eRB_FyNooEwaKX5oqnJQDG980ZnVjv1PFrhHs7keTSVpmuvBLm9z5uI0wY3fkf6eTU6juanHi16aUCuviIHz-FrXdTor3Pn0kdQq4RQdTmu4OqNX3lA_lRoenADcFLwHADtlneuvHZEBsJbeqUg"
              },
              data: {
                'Query': '{checkCustIdGame(custIdGame: "' + this.ticket.TextField_1369.trim().toUpperCase() + '") { ok }}'
              }
            }).then(res => {
              console.log(res);
              if (res.data.code == "3216") {
                this.custCheck = this.$t('m.bind.alertBind')
              }
              else if (res.data.code == "3214") {
                this.custCheck = this.$t('m.bind.alert')
              } else {
                isBindCustId = true

                if (count == true && this.ticketAlert.trim() == '' && this.posting == false && this.custCheck == '') {
                  if (isBindCustId && this.ticket.TextField_1369 != this.getCookie('cust_id_game')) {
                    this.warn = 1

                  } else {
                 
                    if (this.$store.state.captcha.key == '') {
                      var data = {
                        "ticket_plugin_form_id": localStorage.getItem('preferredLang') == 'zh' ? 39 : 38,
                        "type": "customer_token",
                        "type_content": this.$store.state.custId,
                        ticket: {
                          "custom_fields": this.ticket,
                          "attachment_ids": this.attachment_ids,
                          "subject": "测试工单1",
                          "content": this.ticket.TextField_1370 ? this.ticket.TextField_1370 : "工单测试",
                        }
                      }
                    } else {
                      var data = {
                        "ticket_plugin_form_id": localStorage.getItem('preferredLang') == 'zh' ? 39 : 38,
                        "type": "customer_token",
                        "type_content": this.$store.state.custId,
                        "captcha": this.capInput,
                        "captcha_key": this.$store.state.captcha.key,
                        ticket: {
                          "custom_fields": this.ticket,
                          "attachment_ids": this.attachment_ids,
                          "subject": "测试工单1",
                          "content": this.ticket.TextField_1370 ? this.ticket.TextField_1370 : "工单测试",
                        }
                      }
                    }
                    this.capAccept = false
                    this.$udesk.sdk
                      .request(data).saveTicket(data).then(res => {
                        console.log(res);
                        this.$store.commit("SaveTicket", {});

                        if (res.code == 2016) {
                          this.captchaAlert = this.$t('m.ticket.codeAlert');
                          this.posting = false
                          this.capAccept = true
                        } else {
                          this.posting = true
                          
                          this.getTicketId()

                          // this.go()
                        }

                      })
                  }

                }
              }
            })
          } catch (error) {
            // 处理错误，例如输出错误信息
            console.error(error);
          } finally {
            // 在最后，无论成功还是失败，允许将来的提交。

            this.canSubmit = true;


          }

        }
      } else {
        if (count == true && this.ticketAlert.trim() == '' && this.posting == false) {

          if (this.$store.state.captcha.key == '') {
            var data = {
              "ticket_plugin_form_id": localStorage.getItem('preferredLang') == 'zh' ? 39 : 38,
              "type": "customer_token",
              "type_content": this.$store.state.custId,
              ticket: {
                "custom_fields": this.ticket,
                "attachment_ids": this.attachment_ids,
                "subject": "测试工单1",
                "content": this.ticket.TextField_1370 ? this.ticket.TextField_1370 : "工单测试",
              }
            }
          } else {
            var data = {
              "ticket_plugin_form_id": localStorage.getItem('preferredLang') == 'zh' ? 39 : 38,
              "type": "customer_token",
              "type_content": this.$store.state.custId,
              "captcha": this.capInput,
              "captcha_key": this.$store.state.captcha.key,
              ticket: {
                "custom_fields": this.ticket,
                "attachment_ids": this.attachment_ids,
                "subject": "测试工单1",
                "content": this.ticket.TextField_1370 ? this.ticket.TextField_1370 : "工单测试",
              }
            }
          }
          try {
            this.capAccept = false
            await this.$udesk.sdk
              .request(data).saveTicket(data).then(res => {
                console.log(res);
                this.$store.commit("SaveTicket", {});

                if (res.code == 2016) {
                  this.captchaAlert = this.$t('m.ticket.codeAlert');
                  this.capAccept = true
                  this.posting = false
                } else {
                  this.posting = true
                  this.getTicketId()
                  console.log("33333");
                  // this.go()
                }

              })
          } catch (error) {
            // 处理错误，例如输出错误信息
            console.error(error);
          } finally {
            // 在最后，无论成功还是失败，允许将来的提交。
            this.canSubmit = true;
          }

        }else{
          this.canSubmit = true;
        }
      }

    },
    noBind() {
      this.warn = false
      this.posting = true
      if (this.$store.state.captcha.key == '') {
        var data = {
          "ticket_plugin_form_id": localStorage.getItem('preferredLang') == 'zh' ? 39 : 38,
          "type": "customer_token",
          "type_content": this.$store.state.custId,
          ticket: {
            "custom_fields": this.ticket,
            "attachment_ids": this.attachment_ids,
            "subject": "测试工单1",
            "content": this.ticket.TextField_1370 ? this.ticket.TextField_1370 : "工单测试",
          }
        }
      } else {
        var data = {
          "ticket_plugin_form_id": localStorage.getItem('preferredLang') == 'zh' ? 39 : 38,
          "type": "customer_token",
          "type_content": this.$store.state.custId,
          "captcha": this.capInput,
          "captcha_key": this.$store.state.captcha.key,
          ticket: {
            "custom_fields": this.ticket,
            "attachment_ids": this.attachment_ids,
            "subject": "测试工单1",
            "content": this.ticket.TextField_1370 ? this.ticket.TextField_1370 : "工单测试",
          }
        }
      }
      this.$udesk.sdk
        .request(data).saveTicket(data).then(res => {
          console.log(res);
          this.$store.commit("SaveTicket", {});

          if (res.code == 2016) {
            this.captchaAlert = this.$t('m.ticket.codeAlert');
            this.posting = false
          } else {
            this.getTicketId()

            // this.go()
          }

        })

    },
    bindId() {
      this.$axios({
        method: 'post',
        url: this.$backend.host,
        headers: {
          'x-source': 'Nemo',
          jwt: localStorage.getItem('result_code'),
          // jwt: "eyJhbGciOiJQUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbnYiOiJTdGFuZGFsb25lIiwiZXhwIjoxNjY1NDk0ODUwLCJpYXQiOjE2NjU0NjYwNTAsImlkIjoiUktHTUM3IiwiaXNzIjoiUmVjcmVhdGUiLCJqdGkiOiI3cmhsSE0xdkM1VzlicTBYS2ctNFJ3Iiwiand0VHlwZSI6Ik9mZmljaWFsU2l0ZSIsIm5iZiI6MTY2NTQ2NjA1MCwicGxhdGZvcm1fdHlwZSI6MCwic3ViIjoiSHVydEVhY2hPdGhlciJ9.mDht7GqEFDuXbL9zX1JrXcUmvy2b2bExanXA_sNngd2w9r4meeIVj49NgecF39bw4o5Q8hTva4YJLJOiirk2eI4R_HtYF77acTbYwXlGk_xb1ZzV6nGjTJ-c6IAkg0-aQi913fptAryYQKXfLy2iMJGXs4pFTgWEpSmWgCor6e6wrEAJytUCq-DBS9dWVAEhOk2eRB_FyNooEwaKX5oqnJQDG980ZnVjv1PFrhHs7keTSVpmuvBLm9z5uI0wY3fkf6eTU6juanHi16aUCuviIHz-FrXdTor3Pn0kdQq4RQdTmu4OqNX3lA_lRoenADcFLwHADtlneuvHZEBsJbeqUg"
        },
        data: {
          'Query': 'mutation { bindCustIdGame (custId: "' + this.ticket.TextField_1369.toUpperCase() + '") { ok } }'
        }
      }).then(res => {
        console.log(res);
        if (res.data.code == "3216") {
          this.warn = 3
          this.alert = this.$t('m.bind.alertBind')
        } else if (res.data.result.bindCustIdGame.ok) {

          this.warn = 2
          this.$cookie.set('cust_id_game', this.ticket.TextField_1369.toUpperCase())
          this.time = 10
          var timer = setInterval(() => {
            this.time--
            if (this.time == 0) {
              clearInterval(timer)
              this.warn = false
              this.posting = true
              if (this.$store.state.captcha.key == '') {
                var data = {
                  "ticket_plugin_form_id": localStorage.getItem('preferredLang') == 'zh' ? 39 : 38,
                  "type": "customer_token",
                  "type_content": this.$store.state.custId,
                  ticket: {
                    "custom_fields": this.ticket,
                    "attachment_ids": this.attachment_ids,
                    "subject": "测试工单1",
                    "content": this.ticket.TextField_1370 ? this.ticket.TextField_1370 : "工单测试",
                  }
                }
              } else {
                var data = {
                  "ticket_plugin_form_id": localStorage.getItem('preferredLang') == 'zh' ? 39 : 38,
                  "type": "customer_token",
                  "type_content": this.$store.state.custId,
                  "captcha": this.capInput,
                  "captcha_key": this.$store.state.captcha.key,
                  ticket: {
                    "custom_fields": this.ticket,
                    "attachment_ids": this.attachment_ids,
                    "subject": "测试工单1",
                    "content": this.ticket.TextField_1370 ? this.ticket.TextField_1370 : "工单测试",
                  }
                }
              }
              this.$udesk.sdk
                .request(data).saveTicket(data).then(res => {
                  console.log(res);
                  this.$store.commit("SaveTicket", {});
                  console.log();
                  if (res.code == 2016) {
                    this.captchaAlert = this.$t('m.ticket.codeAlert');
                    this.posting = false
                  } else {
                    this.getTicketId()

                    // this.go()
                  }

                })


            }
          }, 1000);



        } else {
          this.warn = 3
          this.alert = this.$t('m.bind.alertBind')
        }
      })



    },
    getTicketId() {
      let langs =
        localStorage.getItem("preferredLang") == "zh" ? "" : "en-us";
      setTimeout(() => {
        this.$udesk.sdk
          .request()
          .getTicketList({ url_lang: langs, page: 1 })
          .then((res) => {
            console.log("工单列表", res);
            // if (res.meta.count == 0) { 

            //   this.getTicketId()
            // } else {
            this.pushId = res.tickets[0].id
            this.$axios({
              method: 'post',
              url: this.$backend.host,
              headers: {
                jwt: localStorage.getItem('result_code'),
                'x-source': 'Nemo'
              },
              data: {
                'Query': 'mutation { addHashIdToTicket ( ticketId: "' + res.tickets[0].id + '"){hashId} }'
              }
            }).then(results => {
              console.log(results);
              this.posting = false
              this.sucess = true

              this.ticketId = results.data.result.addHashIdToTicket.hashId
            })
            this.$store.commit("SaveUdeskList", res)


          })
      }, 3000);

    },
    getCookie(name) {
      var strcookie = document.cookie; //获取cookie字符串
      var arrcookie = strcookie.split("; "); //分割
      //遍历匹配
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name) {
          return arr[1];
        }
      }
      return "";
    },
    checkCustId() {
      console.log("1233");

    }
  },
  created() { },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/ticket.scss";

textarea::-webkit-scrollbar {
  width: 8px;
  /* 设置滚动条宽度 */
}

textarea::-webkit-scrollbar-thumb {
  background-color: #888;
  /* 设置滚动条的颜色 */
  border-radius: 4px;
  /* 设置滚动条的圆角 */
}

textarea::-webkit-scrollbar-thumb:hover {
  background-color: #555;
  /* 设置滚动条的鼠标悬停状态颜色 */
}

.msg-box {
  min-height: 500px;
}

.submit-box {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: MohrRounded Heavy, "FZLanTYK_Black", Microsoft YaHei, sans-serif;
  margin: 0 auto 0;
  flex-wrap: wrap;
}

.submit-box div {

  height: 49px;
  font-family: MohrRounded Heavy, "FZLanTYK_Black", Microsoft YaHei, sans-serif;
  color: #3f4141;
  font-size: 18px;
  padding: 2px 30px 0px !important;
  text-align: center;

  background-color: #ffdd40;
  transition: all 0.5s ease;
  border-radius: 17px;
  line-height: 52px;
}

.submit-box div:hover {
  background-color: #ffc640;
}




#btn {
  min-width: 50px;
  height: 24px;
  font-family: MohrRounded Heavy, 'FZLanTYK_Black', Microsoft YaHei, sans-serif;
  color: #3f4141;
  font-size: 18px;
  text-align: center;
  background-color: #ffdd40;
  line-height: 28px;
  border-radius: 14px;
  padding: 12px 25px;
  transition: all 0.25s ease;
  cursor: pointer;

  &:hover {
    background-color: #ffc640;
  }
}

.drag-over {
  border: 2px dashed #ffbf0084 !important;
  background-color: #ffbf000d !important;
}

.bottom-timer {
  position: relative;
  margin: 10px auto;
  bottom: -15px;
  font-family: 'MohrRounded Black', HYZhengYuan-85W, Microsoft YaHei, sans-serif;
  text-align: center;
}

.sign-loading {
  min-height: 400px;
}

.bottom-timer .greener {
  color: #77c64b;
}

.sign-container .sign-title {
  color: #e66d25;
  font-family: MohrRounded Black, "FZLanTYK_Black", Microsoft YaHei, sans-serif
}

.sign-container .bottom-timer {
  font-size: 16px;
  color: #898989;
}

.sucess-ing svg path {
  width: 68px;
  height: 68px;
}

.sign-container.success {
  width: 600px;
  padding: 60px 50px;
}

.msg-box .update {
  &:first-child {

    margin-top: 10px;

  }

  &:last-child {
    margin-bottom: 5px;
  }
}

.sign-container {
  position: relative;
  padding: 54px 50px;
  max-width: 500px;
  width: 90%;
  margin: 0px 5% 0px;
  border-radius: 48px;
  box-shadow: 0px 4px 8px 0px rgb(0 0 0 / 4%), 0px 8px 16px 0px rgb(0 0 0 / 4%),
    inset 0px -2px 3px 0px rgb(122 122 122 / 10%),
    inset 0px 3px 3px 0px rgb(255 255 255 / 90%);
  background-color: #fcfcfa;
}



.submit-box .sub div {
  cursor: pointer;
  margin: 10px 5px 0;
}

.submit-box .sub.close div {
  background-color: #e6e6e6;
}

.sign-container .sucess-ing {
  display: flex;
  justify-content: center;
}

.sign-title {
  font-size: 40px;
  text-align: center;
  color: #3f4141;
  padding: 10px 0 17px 0;
}
</style>